export const ContainerClass = {
	root: 'gov-container',
}
